import React from 'react'
import { Label, Table } from 'semantic-ui-react'

import CustomerInfo from './CustomerInfo'
import DistanceInfo from './OrderDistanceInfo'
import HighDemandInfo from './HighDemandInfo'
import BlacklistInfo from './BlacklistInfo'

export default class CustomerCell extends React.PureComponent {
  render() {
    const { inProgressOrders, order, showOrderMap, readOnly } = this.props

    return (
      <Table.Cell>
        {inProgressOrders > 1 && (
          <Label circular color="orange">
            Order now: {inProgressOrders}
          </Label>
        )}
        <CustomerInfo order={order} readOnly={readOnly} />
        <hr style={{ margin: 0 }} />
        <DistanceInfo order={order} showOrderMap={showOrderMap} readOnly={readOnly} />
        <HighDemandInfo order={order} />
        <BlacklistInfo order={order} />
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/CustomerCell.js